import { useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import {
  useClients
  // , useDeleteClient
} from '@/hooks/useClients';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from '@/components/ui/dialog';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatClientName } from '@jobos/shared';

export default function ClientList() {
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState('');
  // const [deleteClientId, setDeleteClientId] = useState<string | null>(null);
  const { data: allClients, isLoading, error } = useClients();
  // const { mutateAsync: deleteClient } = useDeleteClient();

  // Client-side filtering
  const clients = useMemo(() => {
    if (!allClients) return [];
    if (!searchInput.trim()) return allClients;

    const searchLower = searchInput.toLowerCase();
    return allClients.filter((client) => {
      const displayName = formatClientName(client.name, client.firstName, client.lastName);
      const nameMatch = displayName.toLowerCase().includes(searchLower);
      const managerMatch = client.managerName?.toLowerCase().includes(searchLower);
      return nameMatch || managerMatch;
    });
  }, [allClients, searchInput]);

  // const handleDelete = async () => {
  //   if (!deleteClientId) return;

  //   try {
  //     await deleteClient(deleteClientId);
  //     setDeleteClientId(null);
  //   } catch (error) {
  //     console.error('Failed to delete client:', error);
  //   }
  // };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-gray-600" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-red-600">
          Error loading clients: {error.message}
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Clients</h1>
              <p className="mt-2 text-sm text-gray-700">
                Manage your client contacts and information
              </p>
            </div>
            <Link to="/clients/new">
              <Button>Create New Client</Button>
            </Link>
          </div>

          {/* Search */}
          <div className="mt-6">
            <Input
              type="search"
              placeholder="Search clients by name..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="max-w-md"
            />
          </div>
        </div>

        {/* Clients Table */}
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Manager</TableHead>
                <TableHead>Contact Info</TableHead>
                {/* <TableHead className="text-right">Actions</TableHead> */}
              </TableRow>
            </TableHeader>
            <TableBody>
              {clients && clients.length > 0 ? (
                clients.map((client) => (
                  <TableRow
                    key={client.id}
                    onClick={() => navigate(`/clients/${client.id}`)}
                    className="cursor-pointer hover:bg-gray-50"
                  >
                    <TableCell className="font-medium">
                      {formatClientName(client.name, client.firstName, client.lastName)}
                    </TableCell>
                    <TableCell>{client.managerName || '-'}</TableCell>
                    <TableCell>{client.contactInfo || '-'}</TableCell>
                    <TableCell className="text-right">
                      <div className="flex justify-end gap-2">
                        {/* <Dialog
                          open={deleteClientId === client.id}
                          onOpenChange={(open: any) =>
                            setDeleteClientId(open ? client.id : null)
                          }
                        >
                          <DialogTrigger asChild>
                            <Button variant="destructive" size="sm">
                              Delete
                            </Button>
                          </DialogTrigger>
                          <DialogContent>
                            <DialogHeader>
                              <DialogTitle>Delete Client</DialogTitle>
                              <DialogDescription>
                                Are you sure you want to delete {client.name}?
                                This action cannot be undone and will fail if
                                the client has associated locations or jobs.
                              </DialogDescription>
                            </DialogHeader>
                            <DialogFooter>
                              <Button
                                variant="outline"
                                onClick={() => setDeleteClientId(null)}
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="destructive"
                                onClick={handleDelete}
                              >
                                Delete
                              </Button>
                            </DialogFooter>
                          </DialogContent>
                        </Dialog> */}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className="text-center py-8">
                    <div className="text-gray-500">
                      <p className="text-lg font-medium">No clients found</p>
                      <p className="text-sm mt-1">
                        {searchInput
                          ? 'Try adjusting your search terms'
                          : 'Get started by creating your first client'}
                      </p>
                      {!searchInput && (
                        <Link to="/clients/new">
                          <Button className="mt-4">Create New Client</Button>
                        </Link>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
  );
}
